import { Paper, Text, Group, Badge, Stack, ActionIcon, Tooltip } from '@mantine/core';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import type { Address } from '@/types';

interface AddressCardProps {
  address: Address;
  onEdit: (address: Address) => void;
  onDelete: (address: Address) => void;
}

export default function AddressCard({ address, onEdit, onDelete }: AddressCardProps) {
  return (
    <Paper withBorder p="md" radius="md">
      <Stack gap="xs">
        <Group justify="space-between">
          <Text fw={600} size="sm">
            {address.label}
          </Text>
          <Group gap="xs">
            {address.is_default && (
              <Badge variant="light" size="sm">
                Default
              </Badge>
            )}
            <ActionIcon variant="subtle" size="sm" onClick={() => onEdit(address)}>
              <IconPencil size={14} />
            </ActionIcon>
            <Tooltip
              label="Cannot delete default address"
              disabled={!address.is_default}
            >
              <ActionIcon
                variant="subtle"
                color="red"
                size="sm"
                disabled={address.is_default}
                onClick={() => onDelete(address)}
              >
                <IconTrash size={14} />
              </ActionIcon>
            </Tooltip>
          </Group>
        </Group>
        <Text size="sm">{address.street}</Text>
        <Text size="sm">
          {address.city}, {address.state} {address.zip_code}
        </Text>
        {address.delivery_instructions && (
          <Text size="xs" c="dimmed" fs="italic">
            {address.delivery_instructions}
          </Text>
        )}
      </Stack>
    </Paper>
  );
}
